import * as angular from 'angular';



export const globalModule =  angular.module('global', ['ui.router']);
